import { render } from "./ModalNotifications.vue?vue&type=template&id=c0432086&scoped=true"
import script from "./ModalNotifications.vue?vue&type=script&lang=js"
export * from "./ModalNotifications.vue?vue&type=script&lang=js"

import "./ModalNotifications.vue?vue&type=style&index=0&id=c0432086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0432086"]])

export default __exports__